

import AdvancedSetupSettings from "@/components/proactive-chats/advanced-setup-settings/advanced-setup-settings";
import { Card } from "@/components/ui/card";


const AdvancedSetup = () => {
    return (
        <Card className="p-6">
            <AdvancedSetupSettings />
        </Card>
    );
};

export default AdvancedSetup;
